import React from 'react'

const CheckCircle = ({ className }) => (
  <svg
    className={className}
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
  >
    <circle
      cx='5.28223'
      cy='5.05859'
      r='4.83333'
      fill='#CFF6E8'
      stroke='#442E83'
      strokeWidth='0.333333'
    />
    <path
      d='M3.28223 5.05843L4.61556 6.39176L7.28223 3.7251'
      stroke='#442E83'
      strokeWidth='0.666667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default CheckCircle
